<template>
  <div style="height: 100%">
    <label style="padding: 20px 0px 10px 30px;">UPS设备</label>
    <div v-if="chartDataList.length > 0" style="height: 85%">
      <!-- 5个及以下设备直接显示 -->
      <template v-if="chartDataList.length === 1">
        <div style="height: 100%">
          <UPSBarChart :data="chartDataList[0]" style="height: 100%;"></UPSBarChart>
        </div>
      </template>
      <!-- 超过5个设备使用轮播 -->
      <template v-else>
        <el-carousel 
          :interval="10000" 
          indicator-position="none" 
          :autoplay="true" 
          style="height: 100%;z-index: 0">
          <el-carousel-item v-for="(chartData, index) in chartDataList" :key="index">
            <UPSBarChart :data="chartData" style="height: 100%;"></UPSBarChart>
          </el-carousel-item>
        </el-carousel>
      </template>
    </div>
    <div v-else style="height: 100%;padding-top: 20%">
      <no-data></no-data>
    </div>
  </div>
</template>

<script>
import UPSBarChart from "@/components/echarts/UPSBarChart";
import NoData from "@/components/NoData";
import { getSpecialTypeValues } from "@/network/measuring-point-history";

export default {
  name: "controlRoomUPSBar",
  components: { UPSBarChart, NoData },
  data() { 
    return {
      chartDataList: [],
      pageSize: 5,
      deviceType: 'PM_UPS', // UPS类型
      pointCodes: 'aiv,biv,civ' // A相输入电压,B相输入电压,C相输入电压
    };
  },
  mounted() {
    this.getData();
  },
  created() {
    this.$store.dispatch('addIntervalObj', { 'getUPSBarData:10000': this.getData })
  },
  destroyed() {
    this.$store.dispatch('removeIntervalObj', 'getUPSBarData')
  },
  methods: {
    getData() {
      getSpecialTypeValues(this.deviceType, this.pointCodes).then(res => {
        if (res.code === 0 && res.data) {
          const { devices, devicePointNames, devicePointValues, thresholdValues } = res.data;
          if (devices && devices.length > 0) {
            const validData = this.processData(devices, devicePointValues);
            const thresholds = this.processThresholds(thresholdValues, devicePointNames);
            
            // 获取三个测点的名称
            const firstDevicePoints = (devicePointNames && devicePointNames[0]) || [];
            const pointNames = [
              firstDevicePoints[0] || 'A相输入电压',
              firstDevicePoints[1] || 'B相输入电压',
              firstDevicePoints[2] || 'C相输入电压'
            ];

            if (validData.length > 0) {
              this.chartDataList = this.chunkData(validData, this.pageSize, thresholds, pointNames);
            } else {
              this.chartDataList = [];
            }
          } else {
            this.chartDataList = [];
          }
        } else {
          this.chartDataList = [];
        }
      }).catch(() => {
        this.chartDataList = [];
      });
    },
    // 处理接口返回的数据
    processData(devices, devicePointValues) {
      const result = [];
      for (let i = 0; i < devices.length; i++) {
        const device = devices[i];
        const values = devicePointValues[i];
        if (device && values && values.length > 0) {
          result.push({
            deviceName: device.name || '未知设备',
            status: device.status,
            aInputVoltage: values[0] || 0,
            bInputVoltage: values[1] || 0,
            cInputVoltage: values[2] || 0
          });
        }
      }
      return result;
    },
    // 处理阈值数据
    processThresholds(thresholdValues, devicePointNames) {
      if (!thresholdValues || thresholdValues.length === 0) return null;
      const result = {};
      
      const firstDevicePoints = (devicePointNames && devicePointNames[0]) || [];
      const names = [
        firstDevicePoints[0] || 'A相输入电压',
        firstDevicePoints[1] || 'B相输入电压',
        firstDevicePoints[2] || 'C相输入电压'
      ];
      
      // 处理三个测点的阈值
      // 0: A相, 1: B相, 2: C相
      ['stageA', 'stageB', 'stageC'].forEach((key, index) => {
        if (thresholdValues[index] && thresholdValues[index].length > 0) {
          result[key] = thresholdValues[index].map(item => ({
            alarmHigh: item.alarmHigh,
            alarmLow: item.alarmLow,
            levelColor: item.alarmLevel ? item.alarmLevel.levelColor : '#ff0000',
            levelName: item.alarmLevel ? item.alarmLevel.levelName : '',
            pointName: names[index]
          }));
        }
      });

      return result;
    },
    // 将数据分组
    chunkData(data, size, thresholds, pointNames) {
      const result = [];
      for (let i = 0; i < data.length; i += size) {
        const chunk = data.slice(i, i + size);
        result.push({
          deviceNames: chunk.map(item => item.deviceName),
          statuses: chunk.map(item => item.status),
          aInputVoltages: chunk.map(item => item.aInputVoltage),
          bInputVoltages: chunk.map(item => item.bInputVoltage),
          cInputVoltages: chunk.map(item => item.cInputVoltage),
          thresholds: thresholds,
          pointNames: pointNames
        });
      }
      return result;
    }
  }
}
</script>

<style scoped>
label {
  font-weight: bold;
  color: #01EFFD;
}

.el-carousel >>> .el-carousel__arrow {
  top: 5%;
}
</style>